import { NgModule } from '@angular/core';
import { BxSplashScreenService } from '@core/services/splash-screen/splash-screen.service';

@NgModule({
    providers: [
        BxSplashScreenService
    ]
})
export class SplashScreenModule
{
    /**
     * Constructor
     */
    constructor(private _bxSplashScreenService: BxSplashScreenService)
    {
    }
}
